import type { Appointment, DemoDate, Service, Staff } from "./types";

export const REFERENCE_NOW = "2026-07-31T09:00:00+07:00";
export const DEPOSIT = 100_000;

export const services: Service[] = [
  {
    id: "gel-tay",
    category: "Nail",
    name: "Gel tay gọn màu",
    description: "Sửa phom, chăm da viền và gel một màu.",
    price: 280_000,
    duration: 45,
    staffIds: ["uyen", "nhi"],
    accent: "#e35f45"
  },
  {
    id: "nail-art",
    category: "Nail",
    name: "Nail art theo mẫu",
    description: "Tối đa bốn ngón vẽ chi tiết, duyệt màu trước khi làm.",
    price: 520_000,
    duration: 75,
    staffIds: ["uyen"],
    accent: "#5a2143"
  },
  {
    id: "combo-tay-chan",
    category: "Nail",
    name: "Combo tay & chân",
    description: "Chăm móng cơ bản, gel tay và chân cùng bảng màu.",
    price: 680_000,
    duration: 90,
    staffIds: ["uyen", "nhi"],
    accent: "#c991a9"
  },
  {
    id: "tao-dang-brow",
    category: "Brow",
    name: "Tạo dáng chân mày",
    description: "Đo tỉ lệ, tỉa sợi và hướng dẫn giữ dáng tại nhà.",
    price: 260_000,
    duration: 30,
    staffIds: ["ly", "nhi"],
    accent: "#1d6b58"
  },
  {
    id: "brow-tint",
    category: "Brow",
    name: "Brow tint tự nhiên",
    description: "Tạo dáng và nhuộm tông nâu trong, hiệu ứng gọn nhẹ.",
    price: 360_000,
    duration: 45,
    staffIds: ["ly"],
    accent: "#927a45"
  }
];

export const staff: Staff[] = [
  {
    id: "uyen",
    name: "Uyên",
    role: "Nail artist",
    specialty: "Phom móng ngắn, nét mảnh và phối màu",
    initials: "U",
    color: "#e35f45"
  },
  {
    id: "nhi",
    name: "Nhi",
    role: "Nail & brow stylist",
    specialty: "Lịch gọn, combo nhanh và dáng tự nhiên",
    initials: "N",
    color: "#1d6b58"
  },
  {
    id: "ly",
    name: "Ly",
    role: "Brow stylist",
    specialty: "Đo tỉ lệ, brow tint và chăm dáng",
    initials: "L",
    color: "#5a2143"
  }
];

export const dates: DemoDate[] = [
  { iso: "2026-07-31", weekday: "T6", day: "31", month: "07", fullness: "tight" },
  { iso: "2026-08-01", weekday: "T7", day: "01", month: "08", fullness: "open" },
  { iso: "2026-08-02", weekday: "CN", day: "02", month: "08", fullness: "full" },
  { iso: "2026-08-03", weekday: "T2", day: "03", month: "08", fullness: "open" },
  { iso: "2026-08-04", weekday: "T3", day: "04", month: "08", fullness: "tight" },
  { iso: "2026-08-05", weekday: "T4", day: "05", month: "08", fullness: "open" },
  { iso: "2026-08-06", weekday: "T5", day: "06", month: "08", fullness: "open" }
];

export const timeSlots = ["09:00", "09:30", "10:00", "10:30", "14:00", "14:30", "15:30", "16:00", "17:00", "18:00"];

export const bookedSlots = new Set([
  "uyen|2026-07-31|09:30",
  "uyen|2026-07-31|14:00",
  "nhi|2026-07-31|10:00",
  "ly|2026-07-31|17:00",
  "uyen|2026-08-01|10:30",
  "nhi|2026-08-04|15:30"
]);

export const conflictSlot = "uyen|2026-07-31|15:30";

export const initialAppointments: Appointment[] = [
  {
    id: "LUA-0802",
    customer: "Mai",
    serviceIds: ["brow-tint"],
    staffId: "ly",
    date: "2026-08-02",
    time: "10:30",
    status: "upcoming",
    deposit: DEPOSIT,
    note: "Giữ tông nâu lạnh."
  },
  {
    id: "LUA-0731",
    customer: "Mai",
    serviceIds: ["gel-tay"],
    staffId: "nhi",
    date: "2026-07-31",
    time: "17:30",
    status: "upcoming",
    deposit: DEPOSIT,
    locked: true
  }
];
